import { z } from 'zod';
import { PHONE_REGEX, isValidPhoneNumber } from './utils/phone/phone-utils';

export const recipientZ = z.object({
  firstName: z.string().min(1, 'First name is required').max(100, 'First name is too long'),
  lastName: z.string().min(1, 'Last name is required').max(100, 'Last name is too long'),
  email: z.string().email('Invalid email address'),
  phone: z
    .union([
      z.string().length(0), // Empty string is valid
      z.string().regex(/^\d{10}$/, 'Phone number must be exactly 10 digits'), // Accept 10 digits only
      z
        .string()
        .regex(PHONE_REGEX, 'Invalid phone number format')
        .refine(isValidPhoneNumber, 'Please enter a valid US phone number'), // Accept full format
    ])
    .optional(),
  notifyAll: z.boolean().optional(),
});

export type RecipientZ = z.infer<typeof recipientZ>;

export const recipientUpdateZ = recipientZ.partial();

export type RecipientUpdateZ = z.infer<typeof recipientUpdateZ>;
